import { formatDateTime, toast } from '@btsis/ui';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { errorKey } from '@/lib/api';
import { useAuth } from '@/lib/auth-context';

export function ImpersonationBanner() {
  const { user, stopImpersonation } = useAuth();
  const { t } = useTranslation();
  const [pending, setPending] = useState(false);
  if (!user?.impersonation) return null;
  const expired = Date.parse(user.impersonation.expiresAt) <= Date.now();
  return (
    <Alert
      severity="warning"
      role="status"
      sx={{ borderRadius: 0 }}
      action={
        <Button
          color="inherit"
          variant="outlined"
          disabled={pending}
          onClick={async () => {
            setPending(true);
            try {
              await stopImpersonation();
            } catch (error) {
              toast.error(t(errorKey(error)));
              setPending(false);
            }
          }}
        >
          {t('impersonation.return')}
        </Button>
      }
    >
      <Stack>
        <Typography variant="subtitle2">
          {t('impersonation.banner', { name: user.name, email: user.email })}
        </Typography>
        <Typography variant="caption">
          {expired
            ? t('impersonation.expired')
            : t('impersonation.hint', { expiresAt: formatDateTime(user.impersonation.expiresAt) })}
        </Typography>
      </Stack>
    </Alert>
  );
}
